/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 履约报表-获取下拉筛选 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `GET /erp/PerformanceReport/optionsForList`
 */
const getOptionsForListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/optionsForList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表-获取下拉筛选 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `GET /erp/PerformanceReport/optionsForList`
 */
export const getOptionsForList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getOptionsForListRequestConfig, requestData), ...args);
};
getOptionsForList.requestConfig = getOptionsForListRequestConfig;
/**
 * 接口 履约报表详情 - 商品明细 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportGoodsDetail`
 */
const postReportGoodsDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/reportGoodsDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postReportGoodsDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表详情 - 商品明细 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportGoodsDetail`
 */
export const postReportGoodsDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postReportGoodsDetailRequestConfig, requestData),
    ...args
  );
};
postReportGoodsDetail.requestConfig = postReportGoodsDetailRequestConfig;
/**
 * 接口 履约报表列表 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表列表 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 履约报表详情-汇总 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportDetailSummary`
 */
const postReportDetailSummaryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/reportDetailSummary",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postReportDetailSummary",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表详情-汇总 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/reportDetailSummary`
 */
export const postReportDetailSummary = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postReportDetailSummaryRequestConfig, requestData),
    ...args
  );
};
postReportDetailSummary.requestConfig = postReportDetailSummaryRequestConfig;
/**
 * 接口 需求日期履约报表 - sku维度 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/getSkuPerformanceList`
 */
const postGetSkuPerformanceListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/getSkuPerformanceList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSkuPerformanceList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 需求日期履约报表 - sku维度 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/getSkuPerformanceList`
 */
export const postGetSkuPerformanceList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSkuPerformanceListRequestConfig, requestData),
    ...args
  );
};
postGetSkuPerformanceList.requestConfig =
  postGetSkuPerformanceListRequestConfig;
/**
 * 接口 履约报表详情-汇总-货期准确率明细 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/deliveryAccuracyDetails`
 */
const postDeliveryAccuracyDetailsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/deliveryAccuracyDetails",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDeliveryAccuracyDetails",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 履约报表详情-汇总-货期准确率明细 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/deliveryAccuracyDetails`
 */
export const postDeliveryAccuracyDetails = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postDeliveryAccuracyDetailsRequestConfig, requestData),
    ...args
  );
};
postDeliveryAccuracyDetails.requestConfig =
  postDeliveryAccuracyDetailsRequestConfig;
/**
 * 接口 商品货期准确率明细 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/skuDeliveryAccuracyDetails`
 */
const postSkuDeliveryAccuracyDetailsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/skuDeliveryAccuracyDetails",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSkuDeliveryAccuracyDetails",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商品货期准确率明细 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `POST /erp/PerformanceReport/skuDeliveryAccuracyDetails`
 */
export const postSkuDeliveryAccuracyDetails = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSkuDeliveryAccuracyDetailsRequestConfig, requestData),
    ...args
  );
};
postSkuDeliveryAccuracyDetails.requestConfig =
  postSkuDeliveryAccuracyDetailsRequestConfig;
/**
 * 接口 获取货期设置下拉数据 的 **请求配置**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `GET /erp/PerformanceReport/getDeliveryConfig`
 */
const getGetDeliveryConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PerformanceReport/getDeliveryConfig",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetDeliveryConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取货期设置下拉数据 的 **请求函数**
 *
 * @分类 采购API/代采报表/履约报表
 * @请求头 `GET /erp/PerformanceReport/getDeliveryConfig`
 */
export const getGetDeliveryConfig = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetDeliveryConfigRequestConfig, requestData),
    ...args
  );
};
getGetDeliveryConfig.requestConfig = getGetDeliveryConfigRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/performanceReport.js